import React, { useState } from "react";

// 20260828 관리자 화면 공통 인라인 텍스트 수정 셀
// - CLASS TEACHER 탭(WebTeacherClassConfig.js)의 연필 아이콘 클릭 -> 입력창 전환 UI 패턴을 재사용
// - 다만 확인 클릭 시 화면에만 임시 반영하는 CLASS TEACHER 탭과 달리, onSave(newValue)를 통해 즉시 저장(API 호출)하는
//   여러 관리자 화면(로컬 서버/로컬 사이트/라이트 로컬 서버 이름·메모)에서 공용으로 쓰기 위해 별도 파일로 분리함
// - 기존 WebTeacherClassConfig.js 내부의 InlineEditCell/IconPencil은 그대로 두고 영향 없음

const IconPencil = ({ onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
        viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className="lucide-pencil-line-icon"
        onClick={onClick}
        style={{ cursor: 'pointer', marginLeft: 5, verticalAlign: 'middle', color: '#666' }}>
        <path d="M13 21h8" />
        <path d="m15 5 4 4" />
        <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
    </svg>
);

/**
 * InlineEditCell
 * @param {string} value               - 현재 값 (읽기 모드에 표시)
 * @param {string} textClassName       - 읽기 모드 span에 적용할 className
 * @param {string} emptyText           - value가 비어있을 때 표시할 문구
 * @param {string} requiredMessage     - 확인 시 값이 비어있으면 표시할 alert 문구 (없으면 빈 값도 저장 허용)
 * @param {function} onSave            - 확인 클릭 시 즉시 호출 (newValue) => void, 호출부에서 API 저장 처리
 */
const InlineEditCell = ({ value, textClassName = "", emptyText = "", requiredMessage, onSave }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [editValue, setEditValue] = useState(value || "");

    const handleStartEdit = () => {
        setEditValue(value || "");
        setIsEditing(true);
    };

    const handleConfirm = () => {
        const trimmed = (editValue || "").trim();
        if (!trimmed && requiredMessage) {
            alert(requiredMessage);
            return;
        }
        onSave(trimmed);
        setIsEditing(false);
    };

    const handleCancel = () => {
        setEditValue(value || "");
        setIsEditing(false);
    };

    if (isEditing) {
        return (
            <div className="inline-edit-cell">
                <input
                    type="text"
                    className="custom-input inline-edit-input"
                    value={editValue}
                    onChange={(e) => setEditValue(e.target.value)}
                    autoFocus
                />
                <button className="btn-table-action inline-edit-button" onClick={handleConfirm}>확인</button>
                <button className="btn-table-action" onClick={handleCancel}>취소</button>
            </div>
        );
    }

    return (
        <>
            <span className={textClassName} title={value}>
                {value || emptyText}
            </span>
            <IconPencil onClick={handleStartEdit} />
        </>
    );
};

export default InlineEditCell;
export { IconPencil };
